/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFilterX = createReactComponent("filter-x", "IconFilterX", [
  [
    "path",
    {
      d: "M13.758 19.414l-4.758 1.586v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5",
      key: "svg-0"
    }
  ],
  ["path", { d: "M22 22l-5 -5", key: "svg-1" }],
  ["path", { d: "M17 22l5 -5", key: "svg-2" }]
]);

export { IconFilterX as default };
//# sourceMappingURL=IconFilterX.js.map
